module.exports = __webpack_public_path__ + "7a38231175942f2c5678f70ec838d851.png";